module.exports = __webpack_public_path__ + "images/application/i-add-stream-8d4180d5.svg";